import React from 'react';
import { Grid, TAGTypography, Avatar, Divider, TAGLink } from '../../..';

var DoctorInfo = function DoctorInfo(props) {
  var _image$file;

  var bio = props.bio,
      collegeCityState = props.collegeCityState,
      degree = props.degree,
      dentalEducation = props.dentalEducation,
      dentalSpecialties = props.dentalSpecialties,
      facilities = props.facilities,
      firstName = props.firstName,
      gender = props.gender,
      graduationDate = props.graduationDate,
      hireDate = props.hireDate,
      image = props.image,
      isSmall = props.isSmall,
      languages = props.languages,
      lastName = props.lastName,
      location = props.location,
      providerType = props.providerType; //experience year

  var graduationYear = graduationDate && new Date(graduationDate).getFullYear(); //hire year

  var hireYear = hireDate && new Date(hireDate).getFullYear();
  return React.createElement(Grid, {
    container: true,
    direction: "column",
    sx: {
      p: {
        xs: '24px 16px',
        md: '40px'
      },
      width: '100%'
    }
  }, React.createElement(Grid, {
    container: true,
    alignItems: "center",
    spacing: {
      xs: 2,
      md: 3
    },
    sx: {
      marginBottom: {
        xs: '24px',
        sm: '28px'
      }
    }
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(Avatar, {
    src: (image === null || image === void 0 ? void 0 : (_image$file = image.file) === null || _image$file === void 0 ? void 0 : _image$file.url) || image,
    alt: "".concat(firstName, " ").concat(lastName),
    sx: {
      width: {
        xs: '64px',
        md: '104px'
      },
      height: {
        xs: '64px',
        md: '104px'
      }
    }
  })), React.createElement(Grid, {
    item: true,
    sx: {
      flex: 1
    }
  }, React.createElement(TAGTypography, {
    variant: isSmall ? 'bodyMediumSemiBold' : 'h3',
    color: 'text.primary',
    sx: {
      marginBottom: {
        xs: '0px',
        md: '4px'
      },
      display: 'block'
    }
  }, firstName, " ", lastName, degree && ', ' + degree), React.createElement(TAGTypography, {
    variant: "overline",
    color: 'text.secondary',
    sx: {
      marginBottom: {
        xs: '0px',
        md: '4px'
      },
      fontSize: {
        xs: '12px',
        md: '14px'
      },
      lineHeight: '16px',
      display: 'block',
      textTransform: 'uppercase'
    }
  }, providerType), gender && React.createElement(TAGTypography, {
    variant: isSmall ? 'lowestLevel' : 'captionMediumRegular',
    color: 'text.tertiary',
    sx: {
      fontSize: {
        xs: '12px',
        md: '14px'
      },
      lineHeight: '16px',
      display: 'block'
    }
  }, gender), location && React.createElement(TAGTypography, {
    variant: isSmall ? 'lowestLevel' : 'bodySmallSemiBold',
    color: 'text.tertiary'
  }, location))), React.createElement(Grid, {
    container: true,
    sx: {
      marginBottom: '8px'
    }
  }, React.createElement(TAGTypography, {
    variant: "bodyMediumBook",
    color: 'text.secondary'
  }, bio !== null && bio !== void 0 && bio.biography ? bio.biography : bio)), graduationYear && React.createElement(Grid, {
    container: true,
    direction: "column",
    sx: {
      marginBottom: '8px'
    }
  }, React.createElement(TAGTypography, {
    variant: isSmall ? 'bodySmallSemiBold' : 'bodyMediumSemiBold',
    color: 'text.primary',
    sx: {
      display: 'block'
    }
  }, "Experience:"), React.createElement(TAGTypography, {
    variant: isSmall ? 'bodySmallBook' : 'bodyMediumBook',
    color: 'text.secondary',
    sx: {
      display: 'block'
    }
  }, "Practicing since ", graduationYear)), dentalEducation && React.createElement(Grid, {
    container: true,
    direction: "column",
    sx: {
      marginBottom: '8px'
    }
  }, React.createElement(TAGTypography, {
    variant: isSmall ? 'bodySmallSemiBold' : 'bodyMediumSemiBold',
    color: 'text.primary',
    sx: {
      display: 'block'
    }
  }, "Dental education:"), React.createElement(TAGTypography, {
    variant: isSmall ? 'bodySmallBook' : 'bodyMediumBook',
    color: 'text.secondary',
    sx: {
      display: 'block'
    }
  }, dentalEducation, " ", React.createElement("br", null), collegeCityState)), dentalSpecialties && React.createElement(Grid, {
    container: true,
    direction: "column",
    sx: {
      marginBottom: '8px'
    }
  }, React.createElement(TAGTypography, {
    variant: isSmall ? 'bodySmallSemiBold' : 'bodyMediumSemiBold',
    color: 'text.primary',
    sx: {
      display: 'block'
    }
  }, "Dental specialties:"), React.createElement(TAGTypography, {
    variant: isSmall ? 'bodySmallBook' : 'bodyMediumBook',
    color: 'text.secondary',
    sx: {
      display: 'block'
    }
  }, dentalSpecialties)), hireYear && React.createElement(Grid, {
    container: true,
    direction: "column",
    sx: {
      marginBottom: '8px'
    }
  }, React.createElement(TAGTypography, {
    variant: isSmall ? 'bodySmallSemiBold' : 'bodyMediumSemiBold',
    color: 'text.primary',
    sx: {
      display: 'block'
    }
  }, "With Aspen Dental since:"), React.createElement(TAGTypography, {
    variant: isSmall ? 'bodySmallBook' : 'bodyMediumBook',
    color: 'text.secondary',
    sx: {
      display: 'block'
    }
  }, hireYear)), languages && React.createElement(Grid, {
    container: true,
    direction: "column",
    sx: {
      marginBottom: '20px'
    }
  }, React.createElement(TAGTypography, {
    variant: isSmall ? 'bodySmallSemiBold' : 'bodyMediumSemiBold',
    color: 'text.primary',
    sx: {
      display: 'block'
    }
  }, "Languages:"), React.createElement(TAGTypography, {
    variant: isSmall ? 'bodySmallBook' : 'bodyMediumBook',
    color: 'text.secondary',
    sx: {
      display: 'block'
    }
  }, languages.join(', '))), (facilities === null || facilities === void 0 ? void 0 : facilities.length) && React.createElement(React.Fragment, null, React.createElement(Divider, {
    sx: {
      width: '100%',
      backgroundColor: 'neutrals.primary',
      marginBottom: '20px'
    }
  }), React.createElement(Grid, {
    container: true,
    direction: "column",
    sx: {
      marginBottom: '8px'
    }
  }, React.createElement(TAGTypography, {
    variant: "h4",
    color: 'text.primary',
    sx: {
      display: 'block',
      marginBottom: {
        xs: '12px',
        md: '16px'
      }
    }
  }, "Dr. ", lastName, " is also associated with:"), React.createElement(Grid, {
    container: true,
    spacing: 3,
    wrap: "wrap"
  }, facilities.map(function (loc, i) {
    //facilityURL
    var facilityState = loc.address.state.toLowerCase();
    var facilityCity = loc.address.city.replace(/\s+/g, '-').toLowerCase();
    var facilityStreet = loc.address.line1.replace(/\s+/g, '-').toLowerCase();
    var facilityURL = "dentist/".concat(facilityState, "/").concat(facilityCity, "/").concat(facilityStreet);
    return React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6,
      key: i
    }, React.createElement(TAGLink, {
      sx: {
        display: 'inline-block'
      },
      href: facilityURL
    }, React.createElement(TAGTypography, {
      variant: "bodyLargeSemiBold",
      color: 'text.link',
      sx: {
        display: 'block'
      }
    }, loc.name)), React.createElement(TAGTypography, {
      variant: "bodyMediumBook",
      color: 'text.secondary',
      sx: {
        display: 'block'
      }
    }, loc.legalBillingName, " ", React.createElement("br", null), loc.address.line1, ", ", React.createElement("br", null), "".concat(loc.name, " ").concat(loc.address.zipCode)));
  })))));
};

export default DoctorInfo;